document.addEventListener("DOMContentLoaded", (event) => {
  const swiper = new Swiper('.reviews__list', {
    loop: true,
    loopPreventsSliding: true,
    // centeredSlides: true,
    autoplay: {
      delay: 7500,
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    spaceBetween: 9,
    breakpoints: {
      748: {
        spaceBetween: 16,
        slidesPerView: 2.5
      },
      1200: {
        spaceBetween: 16,
        slidesPerView: 4
      },
      1400: {
        spaceBetween: 16,
        slidesPerView: 5
      },
      1920: {
        spaceBetween: 16,
        slidesPerView: 6
      },
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const reviewItems = document.querySelectorAll('.reviews__item');

  reviewItems.forEach(function (item) {
    const readMoreBtn = item.querySelector('.reviews__item-read-more');
    const textWrapper = item.querySelector('.reviews__item-text-wrapper');

    if (readMoreBtn && textWrapper) {
      // Check if the text is overflowing
      if (textWrapper.scrollHeight > textWrapper.clientHeight) {
        readMoreBtn.style.display = 'block'; // Show the button
      } else {
        readMoreBtn.style.display = 'none'; // Hide the button
      }

      readMoreBtn.addEventListener('click', function () {
        textWrapper.classList.toggle('expanded');
        if (textWrapper.classList.contains('expanded')) {
          readMoreBtn.textContent = reviews?.less ?? 'Read less';
        } else {
          readMoreBtn.textContent = reviews?.more ?? 'Read more';
        }
      });
    }
  });
});
